import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react';
const Page = lazy(() => import("@/features/config-comission-table/page.client"));
export const Route = createFileRoute('/_authed/staff/config-comission-table')({
  component: () => (
    <Suspense fallback={null}>
      <Page />
    </Suspense>
  ),
})
